import { render, staticRenderFns } from "./VSelect.vue?vue&type=template&id=74e64de3"
import script from "./VSelect.vue?vue&type=script&lang=ts"
export * from "./VSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports